import React from 'react';
import { connect } from 'react-redux';
import projectConfigs from '../../entity/projects/projectConfig';
import MasterComponent from '../../components/Forms';

const Projects = () => {

  return <MasterComponent
    config={projectConfigs}
  />
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(Projects);
